import { render, staticRenderFns } from "./documentAgentTemplateDialog.vue?vue&type=template&id=21927674&scoped=true&lang=pug"
import script from "./documentAgentTemplateDialog.vue?vue&type=script&lang=js"
export * from "./documentAgentTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./documentAgentTemplateDialog.vue?vue&type=style&index=0&id=21927674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21927674",
  null
  
)

export default component.exports